import React, { useEffect, useState } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;

function MailingListSelector({ onSelect }) {
  const [mailingLists, setMailingLists] = useState([]);
  const [selectedListKey, setSelectedListKey] = useState("");

  useEffect(() => {
    async function fetchMailingLists() {
      try {
        const res = await axios.post(`${API_BASE_URL}/emailgenerator/mailinglists`);
        if (res.data.list_of_details) {
          setMailingLists(res.data.list_of_details);
          // Optionally select first by default
          if (res.data.list_of_details.length > 0) {
            setSelectedListKey(res.data.list_of_details[0].listkey);
            onSelect && onSelect(res.data.list_of_details[0].listkey);
          }
        }
      } catch (error) {
        alert("Failed to fetch mailing lists");
      }
    }
    fetchMailingLists();
  }, [onSelect]);

  const handleChange = (event) => {
    setSelectedListKey(event.target.value);
    onSelect && onSelect(event.target.value);
  };

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel id="mailing-list-label">Select Mailing List</InputLabel>
      <Select
        labelId="mailing-list-label"
        value={selectedListKey}
        label="Select Mailing List"
        onChange={handleChange}
      >
        {mailingLists.map((list) => (
          <MenuItem key={list.listkey} value={list.listkey}>
            {`${list.listname} (Contacts: ${list.noofcontacts})`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MailingListSelector;
